import React   from "react";
import PropTypes   from "prop-types";
import { sortBy as _sortBy } from "lodash";
import Translation from "../../../../commons/i18n/Translation";
import Svg from "../../../../../svg/Svg";

class SearchSuggestionOrganizationPresenter extends React.Component {

    render = () => {
        return <a href={this.props.url} key={this.props.keyHandler + '-item'} className="mywort-search-suggestion-card" >
            <div className="mywort-search-suggestion-card__title">
                <Svg id="fa-users" className="u-text-mywort mywort-search-suggestion-card__title__svg"/>{this.props.label}
            </div>
            <div className="mywort-search-suggestion-card__content">
                {this.props.description}
            </div>
            <div className="mywort-search-suggestion-card__locality">
                {this.props.locality}
            </div>
        </a>
    }
}


class SearchSuggestionPresenter extends React.Component {

    renderSubtitle = () => {
        return <small>{this.props.subtitle ? "(" +this.props.subtitle+ ")": ""}&nbsp;</small>
    };

    render = () => {
        return <a href={this.props.url} key={this.props.keyHandler + '-item'} className="mywort-search-suggestion" >
            <figure>
                <img src={this.props.pictureUrl} alt={this.props.label}/>
            </figure>
            <div className="mywort-search-suggestion__title">
                {this.props.label}
                {this.renderSubtitle()}
            </div>
        </a>
    }
}



export default class SearchSuggestions extends React.Component {

    static propTypes = {
        query : PropTypes.string,
        groups : PropTypes.array,
        localities : PropTypes.array,
        onSetGroup : PropTypes.func,
        onSetLocality : PropTypes.func
    };

    static defaultProps = {
        query : "",
        groups: [],
        localities: [],
        onSetGroup: () => {},
        onSetLocality: () => {}
    };

    constructor(props) {
        super(props)
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        return {
            leftMarginRequired: this.computeMarginLeft()
        }
    };

    componentDidMount = () => {
        this.setState({
            leftMarginRequired: this.computeMarginLeft()
        })
    };

    computeMarginLeft = () => {
        let left = 0;
        let element = document.querySelector('.mywort-teaser-list');
        if(element) {
            left = element.getBoundingClientRect().left;
        }
        return left;
    };

    renderTitleLocality = () => {
        if(this.props.localities.length === 1){
            return Translation.translate("search.suggestions.locality")
        }
        return Translation.translate("search.suggestions.localities")
    };

    renderLocalities =() => {
        if(this.props.localities.length === 0){
            return null
        }
        return <section className="suggestions-section">
            <div className="suggestions-section__content">
                <div className="pure-g">
                    <div className="pure-u-1">
                        <h2 className="suggestions-section__title">
                            <b>{this.props.localities.length}</b> {this.renderTitleLocality()} <b>&quot;{this.props.query}&quot;</b>:
                        </h2>
                    </div>
                </div>
            </div>
            <div className="suggestions-scroller">
                <div className="suggestions-scroller__wrapper" style={{'paddingLeft':this.state.leftMarginRequired+'px'}}>
                    {_sortBy(this.props.localities, 'name').map( (locality, idx) =>
                        <div className="suggestions-scroller__item" key={"locality-sugestion-" + idx}>
                            <SearchSuggestionPresenter
                                keyHandler={"locality-sugestion-" + idx}
                                label={locality.name}
                                subtitle={locality.municipalityName}
                                pictureUrl={locality.picture}
                                url={locality.permaLink}
                                onclick={() => {this.props.onSetLocality(locality)}} />
                        </div>
                    )}
                </div>
            </div>
        </section>
    };

    renderTitleGroup = () => {
        if(this.props.localities.length === 1){
            return Translation.translate("search.suggestions.group")
        }
        return Translation.translate("search.suggestions.groups")
    };


    renderGroups =() => {
        if(this.props.groups.length === 0){
            return null
        }
        return <section className="suggestions-section">
            <div className="suggestions-section__content">
                <div className="pure-g">
                    <div className="pure-u-1">
                        <h2 className="suggestions-section__title">
                            <b>{this.props.groups.length}</b> {this.renderTitleGroup()} <b>&quot;{this.props.query}&quot;</b>:
                        </h2>
                    </div>
                </div>
            </div>
            <div className="suggestions-scroller">
                <div className="suggestions-scroller__wrapper" style={{'paddingLeft':this.state.leftMarginRequired+'px'}}>
                    {_sortBy(this.props.groups, 'name').map( (group, idx) =>
                        <div className="suggestions-scroller__item suggestions-scroller__item--2x" key={"group-sugestion-" + idx}>
                            <SearchSuggestionOrganizationPresenter
                                keyHandler={"group-sugestion-" + idx}
                                label={group.name}
                                locality={group.locality}
                                description={group.description}
                                url={group.permaLink}
                                onclick={() => {this.props.onSetGroup(group)}}
                            />
                        </div>
                    )}
                </div>
            </div>
        </section>
    };

    render = () => {
        if(this.props.groups.length === 0 && this.props.localities.length === 0){
            return null
        }
        return <div className="section">
            {this.renderLocalities()}
            {this.renderGroups()}
        </div>
    }
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/desktop/SearchSuggestions.jsx